import * as Types from './generalActionTypes.js';

const initialState = {
    systemParameters: []
};

export default function general(state = initialState, action) {
    switch (action.type) {
        case Types.SET_SYSTEMPARAMETERS:
            if (state.systemParameters !== action.systemParameters) {
                return Object.assign({}, state, { systemParameters: action.systemParameters });
            }
            return state;
        default:
            return state;
    }
}